import React, { useState, useEffect } from 'react';
import { frontendDb as db } from '../../lib/frontend-db';

const AboutPage = () => {
  const [content, setContent] = useState('');
  const [sectionTitle, setSectionTitle] = useState('Das sind wir!');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    loadAbout();
  }, []);

  const loadAbout = async () => {
    try {
      const about = await db.getAbout();
      if (about) {
        setContent(about.content);
        setSectionTitle(about.section_title || 'Das sind wir!');
      }
    } catch (error) {
      console.error('Error loading about:', error);
      setError('Fehler beim Laden des Über uns-Textes');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    setSuccess(false);

    try {
      await db.updateAbout(content, sectionTitle);
      setSuccess(true);
      
      // Trigger event to update header and other components
      window.dispatchEvent(new CustomEvent('settingsUpdated'));
      console.log('🔄 AboutPage: Settings updated event triggered');
      
      setTimeout(() => setSuccess(false), 3000);
    } catch (error) {
      console.error('Error saving about:', error);
      setError('Fehler beim Speichern des Über uns-Textes');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="animate-pulse">Lädt...</div>;
  }

  return (
    <div className="space-y-6">
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
          {error}
        </div>
      )}

      {success && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-green-700">
          Über uns-Text wurde erfolgreich gespeichert!
        </div>
      )}

      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4 text-[var(--primary-color)]">{sectionTitle}</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Sektions-Titel</label>
            <input
              type="text"
              value={sectionTitle}
              onChange={(e) => setSectionTitle(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
              placeholder="z.B. Das sind wir!"
            />
            <p className="mt-1 text-xs text-gray-500">Diese Überschrift erscheint auf der Startseite und im Admin-Panel</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Inhalt</label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={10}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
              required
              placeholder="Geben Sie hier den Text für die Über uns-Sektion ein..."
            />
          </div>

          <button
            type="submit"
            disabled={saving}
            className="w-full bg-green-700 text-white py-2 px-4 rounded-md hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50"
          >
            {saving ? 'Wird gespeichert...' : 'Speichern'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AboutPage;

